export const indexTopics = [
  { id: 'idx-1', icon: 'ri-vip-crown-line', title: '娱乐圈爆料', desc: '明星八卦一手掌握，最新娱乐圈内幕消息每日更新', count: '1.2万条', color: 'primary' },
  { id: 'idx-2', icon: 'ri-live-line', title: '网红动态', desc: '热门网红最新消息，直播圈、短视频圈一手资讯', count: '9.8千条', color: 'accent' },
  { id: 'idx-3', icon: 'ri-global-line', title: '社会热点', desc: '社会事件深度爆料，第一时间追踪热点话题进展', count: '8.5千条', color: 'secondary' },
  { id: 'idx-4', icon: 'ri-tv-line', title: '综艺揭秘', desc: '热门综艺幕后真相大揭秘，录制现场一手消息', count: '6.3千条', color: 'primary' },
  { id: 'idx-5', icon: 'ri-heart-line', title: '情感八卦', desc: '明星恋情婚姻内幕，娱乐圈情感关系深度解析', count: '1.1万条', color: 'accent' },
  { id: 'idx-6', icon: 'ri-money-dollar-circle-line', title: '财经内幕', desc: '商界大佬不为人知的背后故事，企业内幕深度曝光', count: '5.2千条', color: 'secondary' },
  { id: 'idx-7', icon: 'ri-computer-line', title: '科技圈料', desc: '互联网大佬恩怨情仇，科技公司内部消息抢先看', count: '4.7千条', color: 'primary' },
  { id: 'idx-8', icon: 'ri-football-line', title: '体育圈瓜', desc: '赛场内外劲爆消息，体育明星的花边与内幕', count: '3.9千条', color: 'accent' },
  { id: 'idx-9', icon: 'ri-flight-takeoff-line', title: '海外吃瓜', desc: '国际娱乐圈新鲜事，海外明星八卦一网打尽', count: '2.8千条', color: 'secondary' },
];

export const aboutContent = {
  title: '关于51爆料网',
  paragraphs: [
    '51爆料网成立于2019年，是国内领先的爆料吃瓜聚合平台，致力于为全网用户提供最快、最全、最真实的每日爆料信息。我们汇聚了来自娱乐圈、网红圈、社会热点等多个领域的第一手消息，让每一位吃瓜群众都能在这里找到自己关心的内容。',
    '我们的编辑团队7×24小时不间断追踪全网热点，确保每一条爆料都经过多方核实后第一时间发布。从明星八卦到社会事件，从综艺揭秘到财经内幕，51爆料网始终站在吃瓜第一线，用最快的速度和最全面的视角，为您呈现最精彩的爆料内容。',
    '截至2026年，51爆料网已累计发布超过50万条爆料信息，日均活跃用户突破300万，已成为广大网友获取爆料资讯的首选平台。我们坚持"真实、快速、全面"的原则，用心做好每一条爆料，让吃瓜变得更有价值。',
  ],
  stats: [
    { value: '50万+', label: '累计爆料' },
    { value: '300万+', label: '日活用户' },
    { value: '9大', label: '内容板块' },
    { value: '7×24', label: '全天更新' },
  ],
};

export const comments = [
  { id: 'cmt-1', name: '吃瓜不嫌事大', avatar: 'R', time: '2分钟前', content: '这个爆料太劲爆了！我一直在关注这件事的后续，51爆料网果然是全网最快的，比其他平台早了至少半小时！', likes: 328 },
  { id: 'cmt-2', name: '八卦小能手', avatar: '八', time: '8分钟前', content: '每天醒来第一件事就是打开51爆料网看看今天有什么新瓜，已经养成习惯了，一天不看浑身难受哈哈！', likes: 256 },
  { id: 'cmt-3', name: '深夜吃瓜人', avatar: '深', time: '15分钟前', content: '信息量好大，每一条都想点进去看详情。编辑部辛苦了，这么晚了还在更新，给力！', likes: 189 },
  { id: 'cmt-4', name: '理性吃瓜群众', avatar: '理', time: '22分钟前', content: '相比其他平台，51爆料网的内容确实更靠谱，没有那么多标题党，而且更新频率真的高，推荐给身边朋友了。', likes: 145 },
  { id: 'cmt-5', name: '娱乐圈老司机', avatar: '圈', time: '31分钟前', content: '作为一个追了十年八卦的老吃瓜人，51爆料网的质量确实可以，很多内幕消息都是首发，比那些只会转载的平台强太多了！', likes: 98 },
];

export const carouselItems = [
  {
    id: 'car-1',
    title: '某顶流男星深夜密会神秘女子，疑似新恋情曝光',
    category: '娱乐圈',
    desc: '据知情人士透露，该男星近期频繁出现在某高端小区，与一名神秘女子同进同出，引发各方猜测。消息源称两人已交往数月。',
    tag: '重磅',
  },
  {
    id: 'car-2',
    title: '某知名直播平台内部邮件流出，高层大换血在即',
    category: '网红圈',
    desc: '一份据称来自该平台内部的邮件近日在圈内疯传，内容涉及多位核心高管离职及新一轮融资计划，引发行业震动。',
    tag: '独家',
  },
  {
    id: 'car-3',
    title: '热门综艺节目录制现场突发意外，节目组紧急回应',
    category: '综艺圈',
    desc: '某收视率极高的综艺节目在最新一期录制过程中发生意外状况，多名现场观众在社交平台发布相关消息后迅速引发关注。',
    tag: '突发',
  },
  {
    id: 'car-4',
    title: '某互联网大厂CEO与前合伙人纠纷升级，证据曝光',
    category: '科技圈',
    desc: '双方纠纷持续数月后，一系列内部聊天记录和邮件内容被曝光，揭示了这场商界恩怨背后不为人知的细节。',
    tag: '深度',
  },
  {
    id: 'car-5',
    title: '国际知名导演新片选角内幕流出，多位一线演员竞争',
    category: '影视圈',
    desc: '该导演筹备三年的新作近日传出选角消息，据称多位国内一线演员正在激烈竞争男女主角位置，试镜细节被内部人士透露。',
    tag: '热榜',
  },
];

export const contactContent = {
  title: '我要爆料',
  subtitle: '你有猛料，我有平台',
  desc: '如果你掌握娱乐圈、网红圈、社会热点等领域的第一手消息，欢迎向我们投稿。我们承诺对爆料人信息严格保密，经核实采用的爆料将给予丰厚奖励。你的爆料，可能就是明天的头条！',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@51baoliao.com' },
    { icon: 'ri-wechat-line', label: '微信爆料', value: '51baoliao666' },
    { icon: 'ri-smartphone-line', label: '7×24热线', value: '400-051-5151' },
  ],
};

export const mediaItems = [
  {
    id: 'med-1',
    title: '某女星片场耍大牌全程记录，剧组人员集体吐槽',
    duration: '03:28',
    views: '128.6万',
    category: '娱乐圈',
  },
  {
    id: 'med-2',
    title: '网红带货翻车现场！直播间万人围观尴尬时刻',
    duration: '05:12',
    views: '96.3万',
    category: '网红圈',
  },
  {
    id: 'med-3',
    title: '独家探访：某知名企业总部搬迁背后的真相',
    duration: '08:45',
    views: '73.8万',
    category: '财经圈',
  },
  {
    id: 'med-4',
    title: '综艺录制花絮大公开！未播片段比正片还精彩',
    duration: '04:56',
    views: '62.1万',
    category: '综艺圈',
  },
  {
    id: 'med-5',
    title: '体育圈最新爆料：某冠军选手退役内幕独家披露',
    duration: '06:33',
    views: '55.4万',
    category: '体育圈',
  },
];

export const features = [
  {
    id: 'feat-1',
    icon: 'ri-flashlight-line',
    title: '全网最快',
    desc: '实时追踪全网热点，7×24小时不间断更新，爆料速度领先同行至少30分钟，让你永远快人一步吃上热瓜。',
  },
  {
    id: 'feat-2',
    icon: 'ri-shield-check-line',
    title: '一手消息',
    desc: '拥有遍布各领域的独家信息源，每条爆料均经过多方交叉验证，拒绝虚假消息和标题党，确保内容真实可靠。',
  },
  {
    id: 'feat-3',
    icon: 'ri-stack-line',
    title: '内容丰富',
    desc: '覆盖娱乐圈、网红圈、社会热点、综艺揭秘、财经内幕等9大板块，满足不同类型吃瓜群众的所有需求。',
  },
  {
    id: 'feat-4',
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    desc: '全年365天不间断运营，每天发布数百条新鲜爆料，让你永远有瓜可吃，不会错过任何一个热点话题。',
  },
  {
    id: 'feat-5',
    icon: 'ri-user-heart-line',
    title: '保护隐私',
    desc: '对每一位爆料人信息严格保密，采用多重加密技术确保投稿安全，让爆料人无后顾之忧地分享第一手消息。',
  },
];

export const appContent = {
  title: '随时随地，吃瓜不停',
  subtitle: '51爆料网移动端',
  desc: '下载51爆料网App，第一时间接收爆料推送通知，不错过任何一条热点消息。支持离线阅读、夜间模式、个性化订阅，让吃瓜体验更上一层楼。',
  features: ['实时推送', '离线阅读', '夜间模式', '个性化订阅', '评论互动'],
  platforms: [
    { icon: 'ri-apple-fill', label: 'iOS版', desc: 'App Store 评分 4.8' },
    { icon: 'ri-android-fill', label: '安卓版', desc: '各大应用市场可下载' },
  ],
};

export const updates = [
  {
    id: 'upd-1',
    time: '3分钟前',
    title: '某知名歌手新专辑被曝涉嫌抄袭，原作者发声',
    tag: '音乐圈',
    tagColor: 'primary',
  },
  {
    id: 'upd-2',
    time: '12分钟前',
    title: '国内某短视频平台被曝数据泄露，官方紧急回应',
    tag: '科技圈',
    tagColor: 'accent',
  },
  {
    id: 'upd-3',
    time: '28分钟前',
    title: '某综艺导师选手争执画面曝光，节目组发声辟谣',
    tag: '综艺圈',
    tagColor: 'secondary',
  },
  {
    id: 'upd-4',
    time: '45分钟前',
    title: '某影视公司被曝拖欠员工工资，内部群聊记录流出',
    tag: '影视圈',
    tagColor: 'primary',
  },
  {
    id: 'upd-5',
    time: '1小时前',
    title: '某体育明星代言合同纠纷细节曝光，涉及金额惊人',
    tag: '体育圈',
    tagColor: 'accent',
  },
  {
    id: 'upd-6',
    time: '1小时前',
    title: '某直播平台头部主播合同到期，多家平台争抢签约',
    tag: '网红圈',
    tagColor: 'secondary',
  },
  {
    id: 'upd-7',
    time: '2小时前',
    title: '某知名导演新片投资方撤资，剧组面临停摆危机',
    tag: '影视圈',
    tagColor: 'primary',
  },
];

export const topics = [
  { id: 'tpc-1', name: '某顶流恋情', heat: '980万' },
  { id: 'tpc-2', name: '综艺黑幕', heat: '756万' },
  { id: 'tpc-3', name: '网红翻车', heat: '632万' },
  { id: 'tpc-4', name: '明星离婚', heat: '589万' },
  { id: 'tpc-5', name: '片酬曝光', heat: '521万' },
  { id: 'tpc-6', name: '直播内幕', heat: '478万' },
  { id: 'tpc-7', name: '抄袭风波', heat: '435万' },
  { id: 'tpc-8', name: '代言纠纷', heat: '398万' },
  { id: 'tpc-9', name: '数据造假', heat: '367万' },
  { id: 'tpc-10', name: '合约内幕', heat: '342万' },
];

export const cards = [
  {
    id: 'crd-1',
    title: '某知名女演员被曝与经纪人闹翻，多年合作或将终止',
    excerpt: '据圈内人士透露，该女演员与经纪人之间的矛盾已持续数月，涉及利益分配和职业规划分歧，双方目前已处于冷战状态。',
    category: '娱乐圈',
    time: '2小时前',
    comments: 456,
  },
  {
    id: 'crd-2',
    title: '某大型MCN机构内部管理混乱，多位签约网红集体出走',
    excerpt: '知情人士称该机构存在严重的账目不清和拖欠分成问题，已有至少8位头部网红在合约到期后选择不再续约。',
    category: '网红圈',
    time: '3小时前',
    comments: 321,
  },
  {
    id: 'crd-3',
    title: '某知名企业家被曝海外资产转移，监管部门介入调查',
    excerpt: '一份流出的银行转账记录显示该企业家在过去两年内向海外账户转移了大量资金，目前相关监管机构已开始关注此事。',
    category: '财经圈',
    time: '4小时前',
    comments: 289,
  },
  {
    id: 'crd-4',
    title: '热门综艺剪辑师爆料：正片中删减的精彩片段揭秘',
    excerpt: '一位自称参与过多档热门综艺后期制作的剪辑师匿名接受采访，透露了大量在正式播出版本中被剪掉的精彩内容和幕后故事。',
    category: '综艺圈',
    time: '5小时前',
    comments: 215,
  },
  {
    id: 'crd-5',
    title: '某社交平台被曝利用AI操控热门话题，官方否认',
    excerpt: '技术博主发布分析报告称该平台存在疑似使用AI算法人为操控热搜榜单的行为，平台方面随后发布声明予以否认但未提供技术证据。',
    category: '科技圈',
    time: '6小时前',
    comments: 198,
  },
  {
    id: 'crd-6',
    title: '某国际体育赛事裁判被曝收受贿赂，官方启动调查',
    excerpt: '一份匿名举报材料显示该裁判在近两年的多场关键比赛中存在明显的偏袒判罚，涉嫌收受相关方的巨额贿赂。',
    category: '体育圈',
    time: '7小时前',
    comments: 176,
  },
  {
    id: 'crd-7',
    title: '知名音乐制作人被前员工爆料：长期剽窃他人作品',
    excerpt: '多名曾在该制作人工作室工作过的匿名人士联合发声，指认其多年来系统性剽窃不知名音乐人的原创作品并据为己有。',
    category: '音乐圈',
    time: '8小时前',
    comments: 152,
  },
];

export const ranking = [
  { id: 'rnk-1', rank: 1, title: '某顶流男星深夜密会神秘女子', heat: '热度 980万', trend: 'up' },
  { id: 'rnk-2', rank: 2, title: '知名直播平台内部邮件流出高层大换血', heat: '热度 756万', trend: 'up' },
  { id: 'rnk-3', rank: 3, title: '某知名女演员与经纪人闹翻或将终止合作', heat: '热度 632万', trend: 'up' },
  { id: 'rnk-4', rank: 4, title: '大型MCN机构签约网红集体出走事件', heat: '热度 589万', trend: 'down' },
  { id: 'rnk-5', rank: 5, title: '热门综艺剪辑师匿名爆删减片段', heat: '热度 521万', trend: 'up' },
  { id: 'rnk-6', rank: 6, title: '知名企业家海外资产转移被监管调查', heat: '热度 478万', trend: 'down' },
  { id: 'rnk-7', rank: 7, title: '社交平台被曝利用AI操控热门话题', heat: '热度 435万', trend: 'new' },
];

export const faqItems = [
  {
    id: 'faq-1',
    q: '51爆料网的内容来源是哪里？',
    a: '我们的内容来源主要包括：编辑部自主追踪的全网热点、遍布各领域的独家信息源提供的线索、以及热心网友的投稿爆料。所有内容在发布前均经过编辑团队的多方核实，确保信息的真实性和可靠性。',
  },
  {
    id: 'faq-2',
    q: '如何向51爆料网投稿爆料？',
    a: '你可以通过我们的投稿邮箱 tips@51baoliao.com、微信公众号"51baoliao666"或24小时热线400-051-5151向我们提供爆料线索。对于经核实采用的爆料，我们将根据内容价值给予相应的奖励。',
  },
  {
    id: 'faq-3',
    q: '爆料人的隐私安全如何保障？',
    a: '我们非常重视每一位爆料人的隐私安全。所有投稿均通过加密通道传输，爆料人信息采用多重加密存储，编辑团队签署了严格的保密协议。未经爆料人明确同意，我们绝不会向任何第三方透露爆料人信息。',
  },
  {
    id: 'faq-4',
    q: '51爆料网的内容更新频率是怎样的？',
    a: '我们实行7×24小时不间断更新机制，编辑团队全天候轮班追踪全网热点。通常情况下，重大爆料事件发生后的15-30分钟内即可在51爆料网看到相关报道，日常内容保持每小时多次更新的频率。',
  },
  {
    id: 'faq-5',
    q: '如何判断一条爆料的真实性？',
    a: '我们的编辑团队采用"三方验证"机制：首先核实信息来源的可靠性，然后交叉比对多个独立信息源的描述，最后联系相关方进行求证。只有通过三重验证的内容才会被发布。对于尚未完全核实但具有较高关注度的信息，我们会标注"待核实"标签。',
  },
  {
    id: 'faq-6',
    q: '51爆料网的移动端有哪些功能？',
    a: '我们的移动端App支持实时推送通知、离线阅读、夜间模式、个性化内容订阅、评论互动等多项功能。iOS用户可在App Store搜索"51爆料网"下载，安卓用户可在各大应用市场下载。移动端与网页版数据完全同步。',
  },
];

export const heroStats = [
  { value: '50万+', label: '累计爆料' },
  { value: '300万+', label: '日活吃瓜群众' },
  { value: '15分钟', label: '热点平均响应' },
];

export const footerLinks = {
  sections: [
    {
      title: '内容板块',
      links: [
        { label: '娱乐圈爆料', href: '#index' },
        { label: '网红动态', href: '#index' },
        { label: '社会热点', href: '#index' },
        { label: '综艺揭秘', href: '#index' },
        { label: '财经内幕', href: '#index' },
      ],
    },
    {
      title: '快速入口',
      links: [
        { label: '焦点爆料', href: '#carousel' },
        { label: '视频爆料', href: '#media' },
        { label: '实时快讯', href: '#updates' },
        { label: '热门话题', href: '#topics' },
        { label: '热搜榜单', href: '#ranking' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '本站优势', href: '#features' },
        { label: '我要爆料', href: '#contact' },
        { label: '常见问题', href: '#faq' },
        { label: '移动端下载', href: '#app' },
      ],
    },
  ],
};

export const partnerSection = {
  title: '合作伙伴',
  description: '（合作伙伴信息持续更新中，敬请期待）',
};